import axios from 'axios';
import { getFromLocalStorage } from '../../global/helpers';
import { DeliveryProviderName } from './types';

export class SettingsService {
  static API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v2/`;

  static API_BASE_CARD_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/`;

  static role = getFromLocalStorage('role');

  static getConfig = async () => {
    const response = await axios({
      method: 'get',
      url: `${SettingsService.API_BASE_URL}admin/system`,
    });
    return response.data;
  };

  static setConfig = async (data: { delivery_enabled: boolean }) => {
    const response = await axios({
      method: 'post',
      url: `${SettingsService.API_BASE_URL}admin/system`,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
    return response.data;
  };

  static getCardPayment = async () => {
    const response = await axios({
      method: 'get',
      url: `${SettingsService.API_BASE_CARD_URL}admin/payments/cards`,
    });
    return response.data;
  };

  static setCardPayment = async (data: { enabled: boolean }) => {
    const response = await axios({
      method: 'post',
      url: `${SettingsService.API_BASE_CARD_URL}admin/payments/cards`,
      data: { enabled: data.enabled },
    });
    return response.data;
  };

  static getGlovoEnabledStatus = async () => {
    const response = await axios({
      method: 'get',
      url: `${SettingsService.API_BASE_CARD_URL}glovo/webhooks/store/close/all`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  };

  static setEnambleGlovo = async () => {
    const response = await axios({
      method: 'delete',
      url: `${SettingsService.API_BASE_CARD_URL}glovo/webhooks/store/close/all`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  };

  static setDisableGlovo = async (until: string) => {
    const response = await axios({
      method: 'post',
      url: `${SettingsService.API_BASE_CARD_URL}glovo/webhooks/store/close/all`,
      data: JSON.stringify({
        until,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  };

  static setWoltEnabled = async () => {
    const response = await axios({
      method: 'post',
      url: `${SettingsService.API_BASE_CARD_URL}wolt/auth/call-to-action`,
    });
    return response.data;
  };

  static getDeliveryProviders = async () => {
    const response = await axios({
      method: 'get',
      url: `${SettingsService.API_BASE_URL}admin/delivery/providers`,
    });
    return response.data;
  };

  static setDeliveryProviderEnabled = async (
    provider: DeliveryProviderName,
    enabled: boolean
  ) => {
    const response = await axios({
      method: 'post',
      url: `${SettingsService.API_BASE_URL}admin/delivery/providers/${provider}/enabled`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: { enabled },
    });
    return response.data;
  };
}
